export const ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
export const EPSILON = 0.000001;
//# sourceMappingURL=common.js.map